import { getRoadmapPromoted } from '@/voc/api/roadmaps.api';
import { useRoadmapsItemsStore } from '@/stores/roadmaps-items.store';

const state = {
    promises: {},
};

const mutations = {};

const actions = {
    async loadActiveItemPromotedRoadmapItems (_ctx, { vocItemId }) {
        const { useVocItemsStore } = require('@/stores/voc-items.store'); // TODO: remove require when module is converted to Pinia
        try {
            const roadmapPromoted = await getRoadmapPromoted({ vocItemId });
            useVocItemsStore().setActiveItemPromotedRoadmapItems(roadmapPromoted);
        } catch (error) {
            useVocItemsStore().setError({ error });
            throw error;
        }
    },
    addActiveItemPromotedRoadmapItem (_ctx, promotedRoadmapItem) {
        const { useVocItemsStore } = require('@/stores/voc-items.store'); // TODO: remove require when module is converted to Pinia
        const vocItemsStore = useVocItemsStore();
        const activeItemPromotedRoadmapItems = [
            ...vocItemsStore.activeItemPromotedRoadmapItems,
            promotedRoadmapItem,
        ];
        vocItemsStore.setActiveItemPromotedRoadmapItems(activeItemPromotedRoadmapItems);
    },
    fetchRoadmapItems (_context, { items }) {
        return useRoadmapsItemsStore().loadMany({ items });
    },
};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
